enum TriggerTypes {
  Date = 'date',
  Price = 'price',
}
export default TriggerTypes;
